// fal.ai models the admin can choose from, with fal's list price per call in USD
// (checked 2026-10-07 from https://fal.ai/models/<id>/llms.txt; prices can change, update here).
export interface AiModel { id: string; usd: number; note: string; name?: string }

export const TEXT_MODELS: AiModel[] = [
  { id: 'google/gemini-2.5-flash', usd: 0.001, note: 'Recommended: natural Swahili, fast' },
  { id: 'google/gemini-2.5-flash-lite', usd: 0.001, note: 'Fastest, slightly weaker Swahili' },
  { id: 'openai/gpt-5-mini', usd: 0.001, note: 'Good English, average Swahili' },
  { id: 'anthropic/claude-haiku-4.5', usd: 0.01, note: 'Premium (10× price), strong writing' },
];

// One image = one token. usd is the cost of one 1K image.
export const IMAGE_MODELS: AiModel[] = [
  { id: 'fal-ai/nano-banana-2/edit', name: 'Nano Banana 2', usd: 0.08, note: 'Recommended: keeps the product exact, best quality' },
  { id: 'fal-ai/flux-2-pro/edit', name: 'FLUX.2 Pro', usd: 0.045, note: 'Cheaper, very good photos, less faithful to labels' },
];

// Image-to-video models. usd is one clip at the duration shown (no sound unless noted).
export interface VideoModel extends AiModel { seconds: number; audioUsd?: number; aspects: string[] }
export const VIDEO_MODELS: VideoModel[] = [
  { id: 'fal-ai/minimax/hailuo-02/standard/image-to-video', usd: 0.27, seconds: 6, aspects: ['9:16', '1:1', '16:9', '4:5'], note: 'Recommended: good motion, cheapest' },
  { id: 'fal-ai/bytedance/seedance/v1/pro/image-to-video', usd: 0.27, seconds: 5, aspects: ['9:16', '1:1', '16:9', '4:5'], note: 'Sharp, steady camera (720p)' },
  { id: 'fal-ai/kling-video/v3/pro/image-to-video', usd: 0.56, audioUsd: 0.84, seconds: 5, aspects: ['9:16', '1:1', '16:9', '4:5'], note: 'Cinematic, can add sound' },
  { id: 'fal-ai/veo3.1/fast/image-to-video', usd: 0.8, audioUsd: 1.2, seconds: 8, aspects: ['9:16', '16:9'], note: 'Premium, best with sound; 9:16 or 16:9 only' },
];

export interface DesignerSettings { pointsOnApproval: number; pointsPerSale: number; pointValueTsh: number; testRunsPerDay: number }
export const DESIGNER_DEFAULTS: DesignerSettings = { pointsOnApproval: 100, pointsPerSale: 10, pointValueTsh: 10, testRunsPerDay: 5 };

export interface AiSettings {
  sandbox: boolean;
  textModel: string;
  imageModel: string;
  usdToTsh: number;
  // Free pictures drawn on this server (the small "free" link on the pay page): how many one account may make per 24 hours. 0 = off.
  freePerDay: number;
}

export const AI_DEFAULTS: AiSettings = {
  sandbox: true,
  textModel: TEXT_MODELS[0]!.id,
  imageModel: IMAGE_MODELS[0]!.id,
  usdToTsh: 2600,
  freePerDay: 3,
};

export const modelPrice = (list: AiModel[], id: string): number | null => list.find((m) => m.id === id)?.usd ?? null;
